// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles__loading___2Ex8_"};